import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@material-ui/core";
import { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import queries from "../../utils/dexie/queries";
import { useHistory } from "react-router-dom";

export const ImageSelection = forwardRef(({
    imageLibraryRef
}, ref) => {
    const history = useHistory();
    const [t] = useTranslation();
    const [processingImages, setProcessingImages] = useState(false);

    const handleClickOpenPhotoDialog = () => ref.current.click();

    const onSelectedFilesChanged = async (e) => {
        try {
            if (imageLibraryRef != null && imageLibraryRef.current != null) {
                const files = Array.from(e.target.files);
                if (files) {
                    setProcessingImages(true);
                    
                    await imageLibraryRef.current.addImages(files)
                        .finally(() => {
                            setProcessingImages(false);

                            // Make sure we reset the value of the inputFileRef so the onChangeHandler will be triggered if necessary
                            if (ref.current != null)
                                ref.current.value = "";
                        });
                }
            } else {
                throw new Error("[JobView.js] No image library detected on this page");
            }
        } catch (error) {
            queries.addErrorToLogs(error);
            history.push(`/error`);
        }
    }

    return (
        <>
            <div>
                <input type="file" accept="image/jpeg,image/png,image/bmp" 
                    onChange={onSelectedFilesChanged} className="jobview-inputfile" 
                    multiple="multiple" ref={ref} />
            </div>
            <div style={{ paddingBottom: "15px" }}>
                <Button onClick={(e) => handleClickOpenPhotoDialog(e, false)} disabled={processingImages} variant="outlined" color="primary" autoFocus>
                    <FontAwesomeIcon icon={["fad", "images"]} />
                    <span className="button-text-with-icon" style={{ paddingLeft: "10px" }}>{t("ChoosePicture")}</span>
                </Button>
            </div>
        </>
    );

});